import { fetchConfigurationSucceeded } from '../actions';
import { getConfiguration as getConfigurationApi } from 'common/services/general.service';

export function getConfiguration() {
  return async dispatch => {
    try {
      const configuration = await getConfigurationApi();
      dispatch(fetchConfigurationSucceeded(configuration));
      return configuration;
    } catch (e) {}
  };
}
